module.exports = __webpack_public_path__ + "img/vedio_des_2.578b1cc9.jpg";